import { ParameterDetailDto, ParameterEditDto } from './parameter';

export const mapParameterDetailToEdit = (
  dto: ParameterDetailDto
): ParameterEditDto => ({
  id: dto.id,
  name: dto.name,
  nameNO: dto.nameNO,
  nameEN: dto.nameEN,
  nameDE: dto.nameDE,
  description: dto.description,
  unit: dto.unit,
  active: dto.active,
  corrected: dto.corrected,
  mixParameter: dto.mixParameter,
  decimals: dto.decimals,
  parameterGroupId: dto.parameterGroupId,

  parameterMethods: dto.parameterMethods
});
